document.addEventListener('DOMContentLoaded', () => {
  const overlay = document.getElementById('mwc-zoom-overlay');
  const zoomImg  = document.getElementById('mwc-zoom-img');

  function open(src){
    if (!src) return;
    zoomImg.src = src;
    overlay.style.display = 'flex';
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function close(){
    overlay.style.display = 'none';
    overlay.setAttribute('aria-hidden', 'true');
    zoomImg.removeAttribute('src');
    document.body.style.overflow = '';
  }

  // Only react when an IMG inside a .mwc-zoom group is clicked.
  document.addEventListener('click', (e) => {
    const img = e.target.closest('.mwc-zoom img');
    if (!img) return;

    // use the dataset from THIS image (set by autosrc), else fall back to its own src
    const src = img.dataset.zoomSrc || img.currentSrc || img.src;
    open(src);
  });

  overlay.addEventListener('click', (e) => {
    if (e.target === overlay || e.target === zoomImg) close();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
});
